import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useServices = () => useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data, staleTime: 300000 });
export const useCities = () => useQuery({ queryKey: ["cities"], queryFn: async () => (await api.get("/cities")).data, staleTime: 300000 });
export const useContent = () => useQuery({ queryKey: ["content"], queryFn: async () => (await api.get("/content")).data, staleTime: 300000 });
